//import _ from 'lodash';
import { connect } from 'react-redux';
import { convertToPages } from '../../modules/accounting/document';
import { showErrors } from '../../modules/general';
import { bindActionCreators } from 'redux';

const mapStateToProps = () => {
	return {};
};

const mapDispatchToProps = dispatch => bindActionCreators({
	convertToPages : convertToPages,
	showErrors,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
